import React, { useState } from 'react';
import api from '../api/client';

const EditableUsedBagsTable = ({ 
    recID, 
    sku, 
    API_URL, 
    initialBags = [], 
    readOnly = false,
    highlightErrors = false,
    onBagsUpdated = null // Добавляем новый пропс
}) => {
    const [bags, setBags] = useState(initialBags);
    // Операция с удобрением: мешки приходят с productType = 'fert' (сервер used-bags)
    const isFertOperation = bags.some(b => b.productType === 'fert');
    const [containers, setContainers] = useState([]);
    const [editingRow, setEditingRow] = useState(null);
    const [editData, setEditData] = useState({});
    const [loading, setLoading] = useState(false);

    // Загрузка данных при монтировании компонента
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                // Если передан recID, загружаем данные о мешках
                if (recID) {
                    const bagsResponse = await api.get(
                        `/api/sbproduction/${recID}/used-bags`
                    );
                    setBags(bagsResponse.data);
                }
                
                // Загружаем список контейнеров
                const containersResponse = await api.get(
                    '/api/containers'
                );
                setContainers(containersResponse.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [recID, API_URL]);

    // Функция обновления мешка с callback
    // Функция обновления мешка с передачей данных
const handleUpdateBag = async (updatedBag) => {
  try {
    setLoading(true);
    
    // Находим контейнер
    const container = containers.find(c => c.containerID === updatedBag.containerID);
    const containerWeight = container ? parseFloat(container.containerWeight) : 0;
    
    // Если usedWhole = true, то totalWeight должен быть равен containerWeight
    if (updatedBag.usedWhole) {
      updatedBag.totalWeight = containerWeight.toFixed(2);
    } else {
      // Если totalWeight пустое или не число, ставим 0
      let totalWeight = parseFloat(updatedBag.totalWeight);
      if (isNaN(totalWeight)) {
        totalWeight = 0;
      }
      updatedBag.totalWeight = totalWeight.toFixed(2);
    }
    
    // Добавляем recID в данные для обновления
    const updatePayload = {
      ...updatedBag,
      recID: recID
    };
    
    const response = await api.put(
      `/api/seedslocationwh/update`,
      updatePayload
    );
    
    // Обновляем локальное состояние и передаем обновленные данные
    setBags(prev => {
      // В ответе нет isSubstitute/mainSeedsName — сохраняем их из текущей строки
      const updatedBags = prev.map(bag =>
        bag.bagNum === response.data.bagNum ? { ...bag, ...response.data } : bag
      );
      
      // Вызываем callback с обновленными данными
      if (onBagsUpdated) {
        onBagsUpdated(updatedBags);
      }
      
      return updatedBags;
    });
    
    setEditingRow(null);
    setEditData({});
    return response.data;
  } catch (error) {
    console.error('Error updating bag:', error);
    throw error;
  } finally {
    setLoading(false);
  }
};



// В конце файла обновите defaultProps
EditableUsedBagsTable.defaultProps = {
  readOnly: false,
  initialBags: [],
  highlightErrors: false,
  onBagsUpdated: null // Добавляем новый пропс
};

    // Функция для валидации ввода веса
    const validateWeightInput = (value) => {
        if (value === '') return true;
        
        // Проверяем, что это число с максимум 2 знаками после точки
        const regex = /^\d*(\.\d{0,2})?$/;
        return regex.test(value);
    };

    // Обработчик изменения чекбокса "Used Whole" (в режиме редактирования)
    const handleUsedWholeChange = (checked) => {
        if (!editData.containerID) {
            // Если контейнер не выбран, предлагаем выбрать сначала контейнер
            alert('Please select a container first');
            return;
        }

        const container = containers.find(c => c.containerID === editData.containerID);
        const containerWeight = container ? parseFloat(container.containerWeight).toFixed(2) : "0.00";
        
        setEditData(prev => ({
            ...prev,
            usedWhole: checked,
            totalWeight: checked ? containerWeight : (prev.totalWeight || containerWeight)
        }));
    };

// Обработчик быстрого изменения чекбокса (вне режима редактирования)
const handleQuickUsedWholeChange = async (bag, checked) => {
  if (readOnly) return;
  
  try {
    setLoading(true);
    
    const response = await api.put(
      `/api/seedslocationwh/quick-update-used`,
      {
        seedsID: bag.seedsID,
        bagnumid: bag.bagNum,
        usedWhole: checked,
        recID: recID
      }
    );
    
    // Обновляем локальное состояние и передаем обновленные данные
    setBags(prev => {
      const updatedBags = prev.map(b =>
        b.bagNum === response.data.bagNum ? { ...b, ...response.data } : b
      );
      
      // Вызываем callback с обновленными данными
      if (onBagsUpdated) {
        onBagsUpdated(updatedBags);
      }
      
      return updatedBags;
    });
  } catch (error) {
    console.error('Error updating used whole status:', error);
  } finally {
    setLoading(false);
  }
};

    const handleEditClick = (e, index, bag) => {
        e.preventDefault();
        e.stopPropagation();
        if (readOnly) return;
        
        setEditingRow(index);
        setEditData({
            seedsID: bag.seedsID,
            bagnumid: bag.bagNum,
            containerID: bag.containerID,
            lot: bag.lot,
            totalWeight: bag.totalWeight,
            usedWhole: bag.usedWhole,
            takenWeight: bag.takenWeight != null ? String(bag.takenWeight) : '0.00',
            seedsName: bag.seedsName
        });
    };

    const handleSaveClick = async (e, index) => {
        e.preventDefault();
        e.stopPropagation();
        
        try {
            // Если контейнер не выбран, берем первый доступный
            let containerID = editData.containerID;
            if (!containerID && containers.length > 0) {
                containerID = containers[0].containerID;
            }

            const updateData = {
                seedsID: editData.seedsID,
                bagnumid: editData.bagnumid,
                containerID: containerID,
                lot: editData.lot || '',
                totalWeight: editData.totalWeight || '0.00',
                recID: recID,
                usedWhole: editData.usedWhole || false,
                takenWeight: editData.takenWeight || '0.00'
            };

            await handleUpdateBag(updateData);
        } catch (error) {
            console.error('Error saving bag:', error);
        }
    };

    const handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setEditingRow(null);
        setEditData({});
    };

    // Обработчик изменения веса
    const handleWeightChange = (e) => {
        const value = e.target.value;
        
        // Валидация ввода
        if (validateWeightInput(value)) {
            setEditData(prev => ({
                ...prev,
                totalWeight: value,
                usedWhole: false
            }));
        }
    };

    // Обработчик потери фокуса для поля веса
    const handleWeightBlur = () => {
        if (editData.totalWeight === '' || editData.totalWeight === undefined) {
            setEditData(prev => ({
                ...prev,
                totalWeight: '0.00'
            }));
        } else if (editData.totalWeight !== '') {
            const num = parseFloat(editData.totalWeight);
            if (!isNaN(num)) {
                setEditData(prev => ({
                    ...prev,
                    totalWeight: num.toFixed(2)
                }));
            }
        }
    };

    const handleInputChange = (field, value) => {
        const newData = {
            ...editData,
            [field]: value
        };

        if (field === 'containerID') {
            const container = containers.find(c => c.containerID === value);
            if (container) {
                if (newData.usedWhole) {
                    newData.totalWeight = parseFloat(container.containerWeight).toFixed(2);
                }
            }
        }

        setEditData(newData);
    };

    if (loading && bags.length === 0) {
        return <div style={{ textAlign: 'center', padding: '20px' }}>Loading bags...</div>;
    }

    if (!bags || bags.length === 0) {
        return (
            <div className="used-bags-table-container">
                <h4 style={{ 
                    marginBottom: '15px', 
                    textAlign: 'center',
                    color: highlightErrors ? 'red' : 'inherit'
                }}>
                    Used Bags {highlightErrors && ' - Requires Attention'}
                </h4>
                <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    No bags used for this production
                </div>
                {highlightErrors && (
                    <div style={{
                        color: 'red',
                        backgroundColor: '#ffe6e6',
                        border: '1px solid red',
                        padding: '10px',
                        borderRadius: '4px',
                        marginTop: '15px',
                        fontSize: '12px'
                    }}>
                        <strong>⚠️ Action Required:</strong> 
                        <p>No bags found. Please add used bags information before completing the production.</p>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="used-bags-table-container">
            <h4 style={{ 
                marginBottom: '15px', 
                textAlign: 'center',
                color: highlightErrors ? 'red' : 'inherit'
            }}>
                Used Bags {highlightErrors && ' - Requires Attention'}
            </h4>
            <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse', 
                fontSize: '12px',
                border: highlightErrors ? '2px solid red' : '1px solid #ddd'
            }}>
                <thead>
                    <tr style={{ backgroundColor: '#f5f5f5' }}>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '20%' }}>{isFertOperation ? 'Fertilizer' : 'Seeds Name'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '10%' }}>Bag</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '15%' }}>Container</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '10%' }}
                            title="Weight of the bag now. It changes when the bag is used in a later production">Weight (LB)</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '10%' }}>Taken Weight</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '10%' }}
                            title={`${isFertOperation ? 'Fertilizer' : 'Seeds'} returned to the bag at the end of this production. It stays the same when the bag is used later`}>{isFertOperation ? 'Fertilizer Back' : 'Seeds Back'}</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '10%' }}>Lot</th>
                        <th style={{ border: '1px solid #ddd', padding: '8px', width: '10%', textAlign: 'center' }}>Used Whole</th>
                        {!readOnly && (
                            <th style={{ border: '1px solid #ddd', padding: '8px', width: '15%' }}>Actions</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {bags.map((bag, index) => {
                        // Проверяем валидность мешка для подсветки
                        const isBagValid = bag.usedWhole === true || bag.usedWhole === 1 || 
                                          (parseFloat(bag.weight || 0) > 0);
                        const shouldHighlight = highlightErrors && !isBagValid;
                        
                        return (
                            <tr key={`${bag.bagNum}-${index}`} 
                                style={{
                                    backgroundColor: shouldHighlight ? '#ffe6e6' : 'transparent',
                                    borderLeft: shouldHighlight ? '3px solid red' : 'none'
                                }}>
                                
                                {/* Seeds Name */}
                                <td style={{ 
                                    border: '1px solid #ddd', 
                                    padding: '8px',
                                    color: shouldHighlight ? 'red' : 'inherit',
                                    fontWeight: shouldHighlight ? 'bold' : 'normal'
                                }}>
                                    {bag.isSubstitute && (
                                        <i className="fa-solid fa-right-left"
                                            style={{ marginRight: 6, color: '#d97706' }}
                                            title={`Substitute seed: used instead of ${bag.mainSeedsName}`}></i>
                                    )}
                                    {bag.seedsName || 'N/A'}
                                    {shouldHighlight && (
                                        <div style={{
                                            display: 'inline-block',
                                            marginLeft: '5px',
                                            backgroundColor: 'red',
                                            color: 'white',
                                            borderRadius: '50%',
                                            width: '16px',
                                            height: '16px',
                                            textAlign: 'center',
                                            lineHeight: '16px',
                                            fontSize: '10px',
                                            fontWeight: 'bold'
                                        }}>
                                            !
                                        </div>
                                    )}
                                </td>
                                
                                {/* Bag */}
                                <td style={{ 
                                    border: '1px solid #ddd', 
                                    padding: '8px',
                                    color: shouldHighlight ? 'red' : 'inherit'
                                }}>
                                    {bag.bagNum}
                                </td>
                                
                                {/* Container */}
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    {editingRow === index ? (
                                        <select
                                            value={editData.containerID || ''}
                                            onChange={(e) => handleInputChange('containerID', e.target.value)}
                                            style={{ 
                                                width: '100%', 
                                                padding: '4px',
                                                border: shouldHighlight ? '1px solid red' : '1px solid #ccc'
                                            }}
                                            disabled={loading}
                                        >
                                            <option value="">Select Container</option>
                                            {containers.map(container => (
                                                <option key={container.containerID} value={container.containerID}>
                                                    {container.containerName} ({container.containerWeight} LB)
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        bag.container || 'N/A'
                                    )}
                                </td>
                                
                                {/* Weight */}
                                <td style={{ 
                                    border: '1px solid #ddd', 
                                    padding: '8px',
                                    position: 'relative'
                                }}>
                                    {editingRow === index ? (
                                        <input
                                            type="text"
                                            value={editData.totalWeight || ''}
                                            onChange={handleWeightChange}
                                            onBlur={handleWeightBlur}
                                            style={{ 
                                                width: '100%', 
                                                padding: '4px',
                                                backgroundColor: editData.usedWhole ? '#f0f0f0' : 'white',
                                                border: shouldHighlight ? '1px solid red' : '1px solid #ccc'
                                            }}
                                            placeholder="0.00"
                                            disabled={loading || editData.usedWhole}
                                            title={editData.usedWhole ? "Weight is set to container weight when 'Used Whole' is checked" : "Enter weight (e.g., 5.25)"}
                                            pattern="^\d*(\.\d{0,2})?$"
                                            inputMode="decimal"
                                        />
                                    ) : (
                                        <span style={{ 
                                            fontWeight: shouldHighlight ? 'bold' : (bag.usedWhole ? 'bold' : 'normal'),
                                            color: shouldHighlight ? 'red' : (bag.usedWhole ? '#666' : 'inherit')
                                        }}>
                                            {bag.weight} LB
                                        </span>
                                    )}
                                </td>
                                
                                {/* Taken Weight */}
                                <td style={{
                                    border: '1px solid #ddd',
                                    padding: '8px',
                                    textAlign: editingRow === index ? 'left' : 'right',
                                    color: shouldHighlight ? 'red' : 'inherit'
                                }}>
                                    {editingRow === index ? (
                                        <input
                                            type="text"
                                            value={editData.takenWeight || ''}
                                            onChange={(e) => {
                                                if (validateWeightInput(e.target.value)) {
                                                    setEditData(prev => ({ ...prev, takenWeight: e.target.value }));
                                                }
                                            }}
                                            onBlur={() => {
                                                const num = parseFloat(editData.takenWeight);
                                                setEditData(prev => ({
                                                    ...prev,
                                                    takenWeight: isNaN(num) ? '0.00' : num.toFixed(2)
                                                }));
                                            }}
                                            style={{ width: '100%', padding: '4px', border: '1px solid #ccc' }}
                                            placeholder="0.00"
                                            disabled={loading}
                                            inputMode="decimal"
                                        />
                                    ) : (
                                        `${bag.takenWeight || '0.00'} LB`
                                    )}
                                </td>

                                {/* Seeds Back: возврат на момент этой операции (sbproduction_bags.returnedWeight) */}
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                                    {bag.returnedWeight != null ? `${Number(bag.returnedWeight).toFixed(2)} LB` : '-'}
                                </td>

                                {/* Lot */}
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    {editingRow === index ? (
                                        <input
                                            type="text"
                                            value={editData.lot || ''}
                                            onChange={(e) => handleInputChange('lot', e.target.value)}
                                            style={{ 
                                                width: '100%', 
                                                padding: '4px',
                                                border: shouldHighlight ? '1px solid red' : '1px solid #ccc'
                                            }}
                                            disabled={loading}
                                        />
                                    ) : (
                                        <span style={{
                                            color: shouldHighlight ? 'red' : 'inherit'
                                        }}>
                                            {bag.lot || 'N/A'}
                                        </span>
                                    )}
                                </td>
                                
                                {/* Used Whole */}
                                <td style={{ 
                                    border: '1px solid #ddd', 
                                    padding: '8px', 
                                    textAlign: 'center'
                                }}>
                                    {editingRow === index ? (
                                        <input 
                                            type="checkbox" 
                                            checked={editData.usedWhole || false}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                handleUsedWholeChange(e.target.checked);
                                            }}
                                            disabled={loading || !editData.containerID}
                                            style={{ 
                                                cursor: editData.containerID ? 'pointer' : 'not-allowed',
                                                transform: 'scale(1.2)'
                                            }}
                                            title={!editData.containerID ? "Select container first" : "Mark bag as fully used (sets weight to 0)"}
                                        />
                                    ) : (
                                        <input 
                                            type="checkbox" 
                                            checked={bag.usedWhole || false}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                handleQuickUsedWholeChange(bag, e.target.checked);
                                            }}
                                            style={{ 
                                                cursor: readOnly ? 'not-allowed' : 'pointer',
                                                opacity: readOnly ? 0.5 : 1,
                                                transform: 'scale(1.2)'
                                            }}
                                            disabled={readOnly || loading}
                                            title="Mark bag as fully used (sets weight to 0)"
                                        />
                                    )}
                                </td>
                                
                                {/* Actions */}
                                {!readOnly && (
                                    <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                        {editingRow === index ? (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={(e) => handleSaveClick(e, index)}
                                                    disabled={loading}
                                                    style={{
                                                        background: 'green',
                                                        color: 'white',
                                                        fontSize: '12px',
                                                        border: 'none',
                                                        padding: '2px 4px',
                                                        marginRight: '5px',
                                                        cursor: loading ? 'not-allowed' : 'pointer',
                                                        borderRadius: '3px',
                                                        opacity: loading ? 0.6 : 1
                                                    }}
                                                    title={loading ? "Saving..." : "Save"}
                                                >
                                                    {loading ? (
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                    ) : (
                                                        <i className="fas fa-check"></i>
                                                    )}
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handleCancelClick}
                                                    disabled={loading}
                                                    style={{
                                                        background: 'red',
                                                        color: 'white',
                                                        border: 'none',
                                                        fontSize: '12px',
                                                        padding: '2px 4px',
                                                        cursor: loading ? 'not-allowed' : 'pointer',
                                                        borderRadius: '3px',
                                                        opacity: loading ? 0.6 : 1
                                                    }}
                                                    title="Cancel"
                                                >
                                                    <i className="fas fa-times"></i>
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={(e) => handleEditClick(e, index, bag)}
                                                disabled={loading}
                                                style={{
                                                    background: '#ffffff',
                                                    color: '#333',
                                                    border: '1px solid #ddd',
                                                    padding: '4px 8px',
                                                    cursor: loading ? 'not-allowed' : 'pointer',
                                                    borderRadius: '3px',
                                                    opacity: loading ? 0.6 : 1
                                                }}
                                                title="Edit"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </button>
                                        )}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                        <td colSpan={5} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                            {isFertOperation ? 'Total Fertilizer Back' : 'Total Seed Back'}
                        </td>
                        <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                            {bags.reduce((sum, bag) => sum + (parseFloat(bag.returnedWeight) || 0), 0).toFixed(2)} LB
                        </td>
                        <td colSpan={readOnly ? 2 : 3} style={{ border: '1px solid #ddd' }}></td>
                    </tr>
                </tfoot>
            </table>
            
            {/* Сообщение при наличии ошибок */}
            {highlightErrors && (
                <div style={{
                    color: 'red',
                    backgroundColor: '#ffe6e6',
                    border: '1px solid red',
                    padding: '10px',
                    borderRadius: '4px',
                    marginTop: '15px',
                    fontSize: '12px'
                }}>
                    <strong>⚠️ Action Required:</strong> 
                    <p>For each bag, either:</p>
                    <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                        <li>Check "Used Whole" checkbox, OR</li>
                        <li>Enter weight greater than 0 in the Weight column</li>
                    </ul>
                    <p style={{ marginTop: '8px', fontStyle: 'italic' }}>
                        Bags marked with <span style={{ 
                            display: 'inline-block',
                            backgroundColor: 'red',
                            color: 'white',
                            borderRadius: '50%',
                            width: '16px',
                            height: '16px',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '10px',
                            fontWeight: 'bold'
                        }}>!</span> require attention
                    </p>
                </div>
            )}
        </div>
    );
};

EditableUsedBagsTable.defaultProps = {
    readOnly: false,
    initialBags: [],
    highlightErrors: false,
    onBagsUpdated: null
};

export default EditableUsedBagsTable;